import { db } from './firebase.js'
import { getDoc, doc, setDoc } from "firebase/firestore";
import store from './store';

export async function loadNotes() {
  const docRef = doc(db, "users", store.state.user.uid);
  const docSnap = await getDoc(docRef);

  if (docSnap.exists()) {
    console.log("Document data read:", docSnap.data().notes);
    store.commit("setNotes", docSnap.data().notes);
  } else {
    store.commit("setNotes", []);
    console.log("No such document!");
  }
}

export function saveData(action) {
  let successText = 'Note stored successfully.'
  let errorText = 'Note could not be saved. Please try again later.'
  if (action === 'delete') {
    successText = 'Note deleted successfully.'
    errorText = 'Note could not be deleted. Please try again later.'
  }

    setDoc(doc(db, "users", store.state.user.uid), {
      userData: "some user data",
      notes: store.state.notes,
    })
    .then(res => {
      console.log(`data $action successfully`)
      loadNotes()
      
      const el = document.getElementById('success-hint')
      el.innerHTML = successText
      el.className = 'show'
      setTimeout(function(){ el.className = el.className.replace("show", ""); }, 3000);
    })
    .catch(e => {
      console.error("Error adding document: ", e)

      const el = document.getElementById('error-hint')
      el.innerHTML = errorText
      el.className = 'show'
      setTimeout(function(){ el.className = el.className.replace("show", ""); }, 3000);
    })
}
